import { render, staticRenderFns } from "./ShowDiffDialog.vue?vue&type=template&id=e9054e0a"
import script from "./ShowDiffDialog.vue?vue&type=script&lang=js"
export * from "./ShowDiffDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports